import React from 'react'
import { useLocation } from 'react-router-dom'

interface queryParams {
  get: (param: string) => string | null
}

function useQueryParams(): queryParams {
  const { search } = useLocation()
  const searchParams = React.useMemo(
    () => new URLSearchParams(search),
    [search]
  )
  return { get: (param: string) => searchParams.get(param) }
}

export default useQueryParams
